import { BaseZoneArticlePostParseProcessor } from '@project/components/article/processor/postparse/base-zone-post-parse.processor';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { ProjectModel } from '@project/model/project.model';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';
import { NumberUtils } from '@shared/util/number-utils';

export class EmptyZoneArticlePostParseProcessor extends BaseZoneArticlePostParseProcessor {

  protected updateUsageProperties(articleUsage: ArticleUsageVO, projectModel: ProjectModel): void {
    let articleLength: number = ArticleUsageUtils.getArticleUsageInfoPropertyFloatValue(articleUsage,
      ArticleUsageInfoPropertyDef.ARTICLE_LENGTH);
    if (NumberUtils.isNotNumber(articleLength)) {
      articleLength = projectModel.lastBlockingZoneLength;
      ArticleUsageUtils.setArticleUsageInfoPropertyFloatValue(articleUsage, ArticleUsageInfoPropertyDef.ARTICLE_LENGTH, articleLength);
    }
  }
}
